import * as React from 'react';
import {connect} from 'react-redux';
import * as selectors from '../selectors';
import DownloadState from '../DownloadState';
import {Button} from 'react-bootstrap';
import {Destination} from '../../../../integration/representation/contract';
import {FeatureTypeSummary} from '../../../../integration/representation/feature-type';
import {Feature, FeatureTypeIdWithValidOperations, Operation} from '../../../../integration/representation/feature';
import {
    downloadSosi,
    DownloadSosi
} from '../actions';

interface TagProps {
}

interface DispatchProps {
    doDownloadSosi: DownloadSosi;
}

interface StateProps {
    featureTypes: FeatureTypeSummary[];
    destination: Destination;
    useProjectRef: boolean;
    useContractProjectRef: boolean;
    contractProjectRef: string;
    customProjectRef: string;
    sosiForNvdb123: boolean;
    operations: Operation[];
    srid: string;
    selectedFeatureTypeIdsWithValidOperators: FeatureTypeIdWithValidOperations;
    enableDownloadButton: boolean;
}

type Props = TagProps & StateProps & DispatchProps;

const mapStateToProps = (state: DownloadState): StateProps => {
    return {
        featureTypes: selectors.sortedFeatureTypes(state),
        destination: selectors.destination(state),
        useProjectRef: selectors.useProjectRef(state),
        useContractProjectRef: selectors.useContractProjectRef(state),
        contractProjectRef: selectors.contractProjectRef(state),
        customProjectRef: selectors.customProjectRef(state),
        sosiForNvdb123: selectors.sosiForNvdb123(state),
        operations: selectors.operations(state),
        srid: selectors.srid(state),
        selectedFeatureTypeIdsWithValidOperators: selectors.selectedFeatureTypeIdsWithValidAndSelectedOperations(state),
        enableDownloadButton: selectors.enableDownloadButton(state)
    };
};

const mapDispatchToProps: DispatchProps = ({
    doDownloadSosi: downloadSosi
});


class Component extends React.Component<Props, {}> {


    handleDownloadClick(e: any) {
        const { featureTypes,
                destination,
                useProjectRef,
                useContractProjectRef,
                contractProjectRef,
                customProjectRef,
                sosiForNvdb123,
                srid,
                selectedFeatureTypeIdsWithValidOperators
        } = this.props;

        this.props.doDownloadSosi(featureTypes, selectedFeatureTypeIdsWithValidOperators, sosiForNvdb123, srid, destination, useProjectRef, useContractProjectRef, contractProjectRef, customProjectRef);
    }

    render() {
        const { enableDownloadButton } = this.props;

        return (
            <>
                <Button
                    onClick={(e) => this.handleDownloadClick(e)}
                    disabled={!enableDownloadButton}
                    className={'download-button'}
                >Last ned</Button>
            </>
        );
    }
}

export const DownloadButton = connect(mapStateToProps, mapDispatchToProps)(Component);
